import { Avatar, Card, Divider, Link, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { IContacts } from 'API/contacts';
import {
  ArrowBackBlue,
  PurpleAlert,
  PurpleExternalLink,
  PurpleFax,
  PurplePhone,
} from 'Images';

interface IContactMember {
  member: IContacts;
}

export const ContactMember = ({ member }: IContactMember) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.PersonalTeam);
  const phone1 = member.workPhonePrefix1 + '-' + member.workPhone1;
  const phone2 = member.workPhonePrefix2 + '-' + member.workPhone2;
  const fax = member.faxPrefix + '-' + member.fax;
  const form = member.formLink;

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: isDesktop ? '20px' : '16px',
        border: '0.8px solid',
        borderColor: isDesktop ? 'primary.main' : 'primary.shade_100',
        padding: '16px 16px 24px',
        background: '#fff',
      }}
    >
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        gap={isDesktop ? '40px' : '16px'}
      >
        <Stack overflow={'hidden'} gap={'8px'} width={'302px'} flexShrink={0}>
          <Typography variant={'h5'} whiteSpace={'nowrap'} component='h2'>
            {member.duty}
          </Typography>
          <Typography variant={'body3'}>{member.name}</Typography>
        </Stack>
        {isDesktop && (
          <Divider
            orientation={'vertical'}
            aria-hidden={'true'}
            flexItem
            sx={{ borderColor: 'primary.shade_100' }}
          />
        )}
        <Stack direction={isDesktop ? 'row' : 'column'} width={'421px'}>
          <Stack gap={'12px'}>
            {member.workPhonePrefix1.length > 0 &&
              member.workPhone1.length > 0 && (
                <>
                  {isDesktop ? (
                    <Stack direction={'row'} gap={'8px'}>
                      <Avatar
                        alt={''}
                        src={PurplePhone}
                        sx={{
                          width: isDesktop ? '24px' : '20px',
                          height: isDesktop ? '24px' : '20px',
                        }}
                      />
                      <Typography variant={'body6'} color={'secondary.main'}>
                        {phone1}
                      </Typography>
                    </Stack>
                  ) : (
                    <Link
                      href={'tel:' + phone1}
                      sx={{
                        textDecoration: 'underline',
                      }}
                    >
                      <Stack direction={'row'} gap={'8px'}>
                        <Avatar
                          alt={''}
                          src={PurplePhone}
                          sx={{
                            width: isDesktop ? '24px' : '20px',
                            height: isDesktop ? '24px' : '20px',
                          }}
                        />
                        <Typography variant={'body6'}>{phone1}</Typography>
                      </Stack>
                    </Link>
                  )}
                </>
              )}
            {member.workPhonePrefix2.length > 0 &&
              member.workPhone2.length > 0 && (
                <Link
                  underline={'hover'}
                  href={'tel:' + phone2}
                  sx={{
                    textDecoration: isDesktop ? undefined : 'underline',
                  }}
                >
                  <Stack direction={'row'} gap={'8px'}>
                    <Avatar
                      alt={''}
                      src={PurplePhone}
                      sx={{
                        width: isDesktop ? '24px' : '20px',
                        height: isDesktop ? '24px' : '20px',
                      }}
                    />
                    <Typography variant={'body6'} color={'secondary.main'}>
                      {phone2}
                    </Typography>
                  </Stack>
                </Link>
              )}
            {member.faxPrefix.length > 0 && member.fax.length > 0 && (
              <>
                {isDesktop ? (
                  <Stack direction={'row'} gap={'8px'}>
                    <Avatar
                      alt={''}
                      src={PurpleFax}
                      sx={{
                        width: isDesktop ? '24px' : '20px',
                        height: isDesktop ? '24px' : '20px',
                      }}
                    />
                    <Typography variant={'body6'} color={'secondary.main'}>
                      {fax}
                    </Typography>
                  </Stack>
                ) : (
                  <Link underline={'hover'} href={'tel:' + fax}>
                    <Stack direction={'row'} gap={'8px'}>
                      <Avatar
                        alt={''}
                        src={PurpleFax}
                        sx={{
                          width: isDesktop ? '24px' : '20px',
                          height: isDesktop ? '24px' : '20px',
                        }}
                      />
                      <Typography variant={'body6'} color={'secondary.main'}>
                        {fax}
                      </Typography>
                    </Stack>
                  </Link>
                )}
              </>
            )}
          </Stack>
          <Stack marginTop={isDesktop ? '0px' : '16px'}>
            {form && (
              <Link
                underline={'hover'}
                href={`${process.env.REACT_APP_REDIRECT_URL}${member.formLink}`}
                rel={'noopener'}
              >
                <Stack direction={'row'} gap={'8px'}>
                  <Avatar
                    alt={''}
                    src={PurpleExternalLink}
                    sx={{
                      width: isDesktop ? '24px' : '20px',
                      height: isDesktop ? '24px' : '20px',
                    }}
                  />
                  <Stack direction={'row'}>
                    <Typography variant={'body5'}>
                      {dictionary.formApp}
                    </Typography>
                    <Avatar
                      alt={''}
                      src={ArrowBackBlue}
                      sx={{ width: '20px', height: '20px' }}
                    />
                  </Stack>
                </Stack>
              </Link>
            )}
            {!form && (
              <Stack direction={'row'} gap={'8px'}>
                <Avatar
                  alt={''}
                  src={PurpleAlert}
                  sx={{
                    width: isDesktop ? '24px' : '20px',
                    height: isDesktop ? '24px' : '20px',
                  }}
                />
                <Typography variant={'body6'} whiteSpace={'nowrap'}>
                  {dictionary.formNA}
                </Typography>
              </Stack>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
};
